export const startSeason = new Date(new Date().getFullYear(), 5, 1);
export const endSeason = new Date(new Date().getFullYear(), 8, 10);
